<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.reports.loadingCompanyReports"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.reports.companyReportsCount"
				:loading-info="$store.state.reports.loadingCompanyReports"
				:showOrderBy="true"
				items-type="reports"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				:headers="headers"
				:items="reportsList"
				:server-items-length="$store.state.reports.companyReportsCount"
				item-key="id"
				class="budget-table"
				:loading="$store.state.reports.loadingCompanyReports"
				:options.sync="options"
				loading-text="Cargando datos..."
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.serial="{ item }">
					<div>
						<div style="width:100px;"><b>{{ item.serial?.serial }} - LP{{ item.morphable?.project_line_info?.project_line?.number }} - {{ item.prefix?.prefix }} {{ item.report_index }}</b></div>
						<v-chip
							color="green"
							label
							outlined
							x-small
							v-if="item.id == $store.state.reports.companyReportsLastId"
						>
							<b>Último Creado</b>
						</v-chip>
					</div>
				</template>
				<template v-slot:item.client="{ item }">
					<div class="d-flex align-center">
						<div class="d-flex flex-column flex-grow-1">
							<b>{{ getUserName(item) }}</b>
							<div v-if="item.morphable">{{ item.morphable.client ? item.morphable.client.email:'No identificado'}}</div>
						</div>
						<div class="d-flex align-self-start align-start justify-end">
							<v-tooltip bottom v-if="item.morphable?.client?.company_profile && item.morphable?.client?.accreditation?.status">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#FF1209"
										v-bind="attrs"
										v-on="on">mdi-domain</v-icon>
								</template>
								<span>Cliente Empresa</span>
							</v-tooltip>
							<v-tooltip bottom v-else>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#959595"
										v-bind="attrs"
										v-on="on">mdi-account</v-icon>
								</template>
								<span>Cliente Persona Natural</span>
							</v-tooltip>
						</div>
					</div>
				</template>
				<template v-slot:item.details="{ item }">
					<div>
						<div class="d-flex">
							<div class="d-flex align-center" style="width: 130px;">
								<v-icon small class="mr-2">{{getTypeIcon(item.morphable_type)}}</v-icon> <p class="mb-0 font-weight-bold">{{ getTypeName(item.morphable_type)}}</p>
							</div>
							<ProjectLineAssociationMenu :projectLineAssociations="item.morphable?.associations" :btnClick="() => selectRow(item)"/>
						</div>
						<div class="d-flex align-center">
							<div v-if="item.morphable">
								<div class="d-flex align-center" v-if="item.morphable.responsible" style="width: 130px;">
									<v-icon small class="mr-2" color="green">mdi-account-check-outline</v-icon>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<p
												class="mb-0 text-truncate font-weight-bold"
												v-bind="attrs"
												v-on="on"
											>
												{{ item.morphable.responsible.profile.name + ' ' + item.morphable.responsible.profile.lastname + ' ' + item.morphable.responsible.profile.second_lastname }}
											</p>
										</template>
										<span>{{ item.morphable.responsible.profile.name + ' ' + item.morphable.responsible.profile.lastname + ' ' + item.morphable.responsible.profile.second_lastname }}</span>
									</v-tooltip>
								</div>
								<div v-else style="width: 130px;">
									<v-icon small class="mr-2" color="warning">mdi-account-cancel-outline</v-icon>
									<b>Sin Responsable</b>
								</div>
							</div>
							<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												icon
												color="warning"
												x-small
												@click="selectRow(item)"
												:disabled="!$checkPermissions(['assign_responsible_user'])"
												v-bind="{ ...attrs, ...tooltipAttrs }"
												v-on="{ ...on, ...tooltipOn }"
											>
												<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
											</v-btn>
										</template>
										<span>Cambiar Responsable</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(responsible, index) in $store.state.users.usersList"
											:key="index"
											dense
											@click.stop="() => { selectRow(item); changeResponsible(item, responsible.id); }"
										>
											<v-list-item-title dense>
												<div class="d-flex align-center">
													<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
													<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
													<div>
														<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
														<p class="mb-0 caption">{{ responsible.email }}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</div>
				</template>
				<template v-slot:item.project="{ item }">
					<div class="d-flex flex-column">
						<p class="ml-2 mb-0 font-weight-bold">{{ item.morphable?.name || item.morphable?.info?.project_detail || 'Sin Nombre' }}</p>
						<p class="ml-2 mb-0">{{ item.morphable?.info?.address?.address || 'Sin Dirección' }}</p>
						<p class="ml-2 mb-0">{{ item.morphable?.info?.project_type?.name || 'Sin Tipo de Proyecto' }}</p>
					</div>
				</template>
				<template v-slot:item.status="{ item }">
					<div>
						<div class="d-flex align-center">
							<div>
								<v-chip
									:color="item.last_status?.status | budgetStatusColor"
									label
									outlined
									x-small
									class="px-1"
								>
									<b>{{ item.last_status?.status | budgetStatus }}</b>
								</v-chip>
								<p class="ml-2 mb-0 caption">{{ item.last_status?.description }}</p>
							</div>

							<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										color="warning"
										x-small
										@click="selectRow(item)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Estado</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(status, index) in budgetStatuses"
											:key="index"
											dense
											@click.stop="() => { selectRow(item); changeBudgetStatus(item.id, status.value); }"
										>
											<v-list-item-title dense>
												{{ status.title }}
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</div>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="#959595"
								class="mx-1"
								@click.stop="() => { selectRow(item); toReport(item); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-file-document-outline</v-icon>
							</v-btn>
						</template>
						<span>Ver Informe</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="#959595"
								class="mx-1"
								@click.stop="() => { selectRow(item); reportToPdf(item); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-email-plus-outline</v-icon>
							</v-btn>
						</template>
						<span>Ver PDF y Enviar Informe a Cliente</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="error"
								class="mx-1"
								@click.stop="() => { selectRow(item); startRemoveReport(item.id); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-delete-outline</v-icon>
							</v-btn>
						</template>
						<span>Eliminar</span>
					</v-tooltip>
					<!-- 
					<v-tooltip bottom v-if="$checkPermissions(['edit_users'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								dark
								x-small
								color="warning"
								class="mx-1"
								@click.stop="() => { selectRow(item); editUser(item); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-pencil-outline</v-icon>
							</v-btn>
						</template>
						<span>Editar</span>
					</v-tooltip> -->
					<!-- <v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								dark
								x-small
								color="#31D56A"
								class="mx-1"
								@click.stop="() => { selectRow(item); $router.push({ name: 'Chat', query: { user_id: item.id } }); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-chat-outline</v-icon>
							</v-btn>
						</template>
						<span>Chatear</span>
					</v-tooltip> -->
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.reports.companyReportsCount"
				:loading-info="$store.state.reports.loadingCompanyReports"
				:showOrderBy="true"
				items-type="reports"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {addNewStatus} from '@/helpers/api/budgets'
import {sendReportPdfEmail, deleteReport, createReportPdfFromPreview} from '@/helpers/api/reports'

import {setResponsible as setResponsiblePreProject} from '@/helpers/api/preprojects'
import {setResponsible as setResponsibleProject} from '@/helpers/api/projects'
import {assignScheduleToUser} from '@/helpers/api/crm'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'

export default {
	name: 'ReportsIndex',
	components: {
		DataTablePagination,
		ProjectLineAssociationMenu
	},
  data() {
    return {
      search: '',
			selectedRowItem: null,
			prefixMenu: false,
			searchInput: null,
			lastWorkingBudget: null,
			budgetStatuses: [
				{value: 1, title: 'Creado'},
				{value: 2, title: 'Enviado'},
				{value: 3, title: 'Observado'},
				{value: 4, title: 'Aceptado'},
				{value: 5, title: 'Rechazado'},
			],
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
				order_by: localStorage.getItem('reports_order_by') ? parseInt(localStorage.getItem('reports_order_by')) : 1,
      }
    };
  },
  computed: {
		headers(){
			let headers = [
				{ text: 'Nº', value: 'serial', class: 'with-divider', cellClass: 'with-divider', sortable: false },
				{ text: 'Cliente', value: 'client', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Seguimiento y Responsable', value: 'details', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Proyecto', value: 'project', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Estado', value: 'status', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false },
			]
			return headers.filter((header) => {
				return this.$store.state.reports.listingColumns[header.value]
			})
		},
		reportsList(){
			return this.$store.state.reports.companyReports
		},
    filteredUsers() {
      return this.$store.state.users.usersList.filter(user => {
        return (
          user.name.toLowerCase().includes(this.search.toLowerCase()) ||
          user.email.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		queryRoute(){
			return this.$route.query
		}
  },
	watch: {
    options: {
      handler() {
				this.reloadInfo()
      },
      deep: true,
    },
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
				this.$store.dispatch('users/getUserFromCompany')
			}
		},
		budgetsList(newValue){
			if(newValue){
				this.initialCheck()
			}
		},
		queryRoute(){
			const budget_id = this.$route.query.b
			if(budget_id){
				const data = {
					status: true,
					budget_id,
					force_get: true
				}
				this.$store.commit('general/setNewBudgetModal', data)
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
			this.$store.dispatch('users/getUserFromCompany')
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_report_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		eventBus.$on('changeGeneralOrderList', this.onChangeGeneralOrderList)
    eventBus.$on('reloadInformation', this.debounceReloadInfo)
	},
	beforeDestroy() {
		eventBus.$off('changeGeneralOrderList', this.onChangeGeneralOrderList)
		eventBus.$off('reloadInformation', this.debounceReloadInfo)
	},
  methods: {
		onChangeGeneralOrderList(value){
			this.options.order_by = value
			this.debounceReloadInfo()
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_report_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		async changeBudgetStatus(budget_id, status){
			const resp = await addNewStatus({budget_id, status})
			if(resp.code == 200){
				this.reloadInfo()
			}
		},
		getUserName(report){
			let name = ''
			const item = report.morphable
			if(item.client && item.client.profile){
				name = item.client.profile.name + ' ' + item.client.profile.lastname + ' ' + item.client.profile.second_lastname
			}
			else if(this.getType(report.morphable_type) == 'crm' && item.user){
				if(item.user?.user?.profile){
					name = (item.user?.user?.profile?.name ?? '') + ' ' + 
									(item.user?.user?.profile?.lastname ?? '') + ' ' + 
									(item.user?.user?.profile?.second_lastname ?? '')
				}
				else{
					name = (item.user.name ?? '') + ' ' + 
									(item.user.lastname ?? '') + ' ' + 
									(item.user.second_lastname ?? '')
				}
			}
			else{
				name = 'No identificado'
			}
			return name
		},
		getTypeIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.reloadInfo(this.searchInput)
		},
		reloadInfo(search = null){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(search){
				data = {search}
			}
			this.$store.dispatch('reports/getCompanyReports', data)
		},
		toReport(item){
			this.$router.push({ name: 'ReportDetail', query: { id: item.id } })
		},
    editUser(user) {
			const data = {...user, ...{user_id: user.id, client: true}}
			this.$store.commit('users/setNewUserModalEditing', data)
			this.$store.commit('users/setNewUserModal', true)
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		reverseContentViewToPlaceholders(content) {
			let result = content;
			result = result.replace(/<span id="(.*?)"[^>]*>(.*?)<\/span>/g, (match, placeholder) => {
					return `${placeholder}`;
			})
			return result;
		},
		async reportToPdf(item){
			const data = {
				report_id: item.id,
				contents: JSON.stringify( item.report_html.map(page => this.reverseContentViewToPlaceholders(page) ) )
			}
			const pdf = await createReportPdfFromPreview(data)
			if(pdf.code == 200){
				const report = {...item, ...{pdf: pdf.report_pdf}}
				this.$store.commit('reports/setReportPdfModal', report)
				this.reloadInfo()
			}
		},
		async sendEmailReport(report){
			const report_r = await sendReportPdfEmail({report_id: report.id})
			if(report_r.code === 200){
				this.reloadInfo(this.searchInput)
				const messageData = {
					message: 'Se ha enviado correctamente el informe por correo',
					title: 'Informe enviado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async changeResponsible(item, responsible_id){
			const item_type = this.getType(item.morphable_type)
			if(item_type == 'crm'){
				await assignScheduleToUser({schedule_id: this.conversation.schedule.user_schedule.id, new_user_id: responsible_id})
			}
			else if(item_type == 'preproject'){
				await setResponsiblePreProject({preproject_id: item.morphable_id, responsible_id})
			}
			else if(item_type == 'project'){
				await setResponsibleProject({project_id: item.morphable_id, responsible_id})
			}
			this.reloadInfo()
		},
		startRemoveReport(report_id){
			const confirmation = confirm("¿Estás seguro que quieres eliminar el registro?")
			if(confirmation){
				this.removeReport(report_id)
			}
		},
		async removeReport(report_id){
			await deleteReport({report_id})
			this.reloadInfo()
		},
		gotToAssociation(item){
			const item_type = this.getType(item.morphable_type)
			if(item_type == 'crm'){
				// this.$router.push({ name: 'Conversation', params: { id: item.morphable_id } })
				this.$store.commit('crm/setCrmModalId', item.morphable_id )
			}
			else if(item_type == 'preproject'){
				// this.$router.push({ name: 'PreProject', params: { id: item.morphable_id } })
				this.$store.commit('preprojects/setPreProjectModalId', item.morphable_id)
			}
			else if(item_type == 'project'){
				const messageData = {
					message: 'Detalle de proyectos en futuro módulo Proyectos',
					title: 'Sección en construcción',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		}
  },
};
</script>

<style scoped>
</style>
<style>
.budget-index .message-container{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.budget-index .message-container p{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.budget-table table tr td{
	font-size: 11px!important;
}
.budget-table.resizable .v-data-table__wrapper th,
.budget-table.resizable .v-data-table__wrapper td {
	border-right: 1px solid #cacaca;
}
.with-divider {
  border-right: 1px solid grey;
}
</style>